import { render, staticRenderFns } from "./algooo.vue?vue&type=template&id=09e4964e&scoped=true&"
import script from "./algooo.vue?vue&type=script&lang=js&"
export * from "./algooo.vue?vue&type=script&lang=js&"
import style0 from "./algooo.vue?vue&type=style&index=0&id=09e4964e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e4964e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCalendar } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCalendar,VCheckbox,VDatePicker,VFlex,VIcon,VLayout,VMenu,VSelect,VSheet,VSpacer,VTextField})
